import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { SxStyle } from '../../../../../types';
import { useStringsContext } from '../../../../../contexts/strings';
import AccordionWrapper from '../accordion';
import Box from '@mui/material/Box';
import SelectWithValidate, { SelectOptions } from '../../../../common/input/select-with-validate';
import svStrings from '../../../../../sv-strings';
import { InputWithValidateProps } from '../../../../common/input/text-input-with-validate';
import { PushNotificationValues } from '../../push-notification-send';
import { useSegments } from '../../../../../hooks/useSegments';
import { PushNotification, PushNotificationTarget } from '../../../../../types/notification';

const styles: SxStyle = {
  container: {
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '24px',
  },
};

interface Props extends InputWithValidateProps<PushNotification> {
  selectedAbbrv: string | null;
  pushNotification: PushNotificationValues;
  isReadOnly: boolean;
}

const PushNotificationTargetGroup = ({
  selectedAbbrv,
  pushNotification,
  onValue,
  onValidation,
  hideValidationError,
  isReadOnly,
}: Props) => {
  const { strings } = useStringsContext();

  const [segmentOptions, setSegmentOptions] = useState<SelectOptions>({
    options: [],
    optionsText: [],
  });

  const { query } = useSegments(selectedAbbrv || '');
  const segments = query?.data;

  useEffect(() => {
    if (segments?.length) {
      setSegmentOptions({
        options: segments.map((segment) => segment.id),
        optionsText: segments.map((segment) => segment.name),
      });
    }
  }, [segments]);

  const onTargetValue = (key: keyof PushNotification, segmentId: any) => {
    const segment = query?.data?.find((segment) => segment.id === segmentId) || null;
    if (!segment) {
      return;
    }
    const target: PushNotificationTarget = {
      type: segment.type,
      value: segment.id,
    };
    onValue?.(key, target);
  };

  return (
    <AccordionWrapper expanded={true} name={strings.pushFields.titleTarget}>
      <Box sx={styles.container}>
        <SelectWithValidate<PushNotification>
          name="target"
          options={segmentOptions.options}
          optionsText={segmentOptions.optionsText}
          label={strings.pushFields.initialSelectTarget}
          value={pushNotification?.target?.type}
          validation={yup
            .string()
            .oneOf(segmentOptions.options as string[], svStrings.validations.mustSelectTarget)
            .required(svStrings.validations.isRequired)}
          onValue={onTargetValue}
          onValidation={onValidation}
          disabled={query.isLoading || segmentOptions.options.length === 0 || isReadOnly}
          hideValidationError={hideValidationError}
          fullWidth
        />
      </Box>
    </AccordionWrapper>
  );
};

export default PushNotificationTargetGroup;
